/**
 * sw-pr-gw-customer-dashboard
 * SpendWyze Payment Request Gateway Customer Dashboard
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface BillingReportTasks { 
    /**
     * The unique identifier of the task
     */
    id: string;
    /**
     * Creation date time of the payment request task
     */
    creationDateTime: Date;
    /**
     * Type of the payment request task
     */
    type: BillingReportTasks.TypeEnum;
    /**
     * The name of the transaction's payer.
     */
    payerName?: string;
    /**
     * The amount of the transaction.
     */
    amount?: number;
    /**
     * The comment of the transaction.
     */
    comment?: string;
    /**
     * Status of the payment request task
     */
    status: BillingReportTasks.StatusEnum;
}
export namespace BillingReportTasks {
    export type TypeEnum = 'PAYMENT_REQUEST_UNATTENDED' | 'PAYMENT_REQUEST_PAYER_ATTENDED';
    export const TypeEnum = {
        UNATTENDED: 'PAYMENT_REQUEST_UNATTENDED' as TypeEnum,
        PAYERATTENDED: 'PAYMENT_REQUEST_PAYER_ATTENDED' as TypeEnum
    };
    export type StatusEnum = 'CONFIRMATION_NEEDED' | 'PROCESSING' | 'ACCEPTED_BY_GIRO' | 'REJECTED_BY_GIRO' | 'EXPIRED' | 'DECLINED' | 'COMPLETED' | 'RECALL_PROCESSING' | 'RECALL_REJECTED_BY_GIRO' | 'RECALLED';
    export const StatusEnum = {
        CONFIRMATIONNEEDED: 'CONFIRMATION_NEEDED' as StatusEnum,
        PROCESSING: 'PROCESSING' as StatusEnum,
        ACCEPTEDBYGIRO: 'ACCEPTED_BY_GIRO' as StatusEnum,
        REJECTEDBYGIRO: 'REJECTED_BY_GIRO' as StatusEnum,
        EXPIRED: 'EXPIRED' as StatusEnum,
        DECLINED: 'DECLINED' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        RECALLPROCESSING: 'RECALL_PROCESSING' as StatusEnum,
        RECALLREJECTEDBYGIRO: 'RECALL_REJECTED_BY_GIRO' as StatusEnum,
        RECALLED: 'RECALLED' as StatusEnum
    };
}